'use strict';
module.exports = function asyncIterator(items, asyncProcessor) {
	let remaining = items || [];
	const initial = remaining.length,
		processNext = function (next) {
			return asyncProcessor(next, initial - remaining.length, initial).then(processNextOrResolve); // eslint-disable-line no-use-before-define
		},
		processNextOrResolve = function () {
			let next;
			if (remaining.length) {
				next = remaining[0];
				remaining = remaining.slice(1);
				return processNext(next);
			}
			return Promise.resolve();
		};
	return processNextOrResolve();
};
